module.exports = __webpack_public_path__ + "img/unit1.31cb301e.png";